import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getGenres } from '../../../api';
import useRouteStore from '../../../hooks/useRouteStore';
import SearchBar from '../../../common/SearchBar';

const AdminGenres = () => {
  const [genres, setGenres] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const setRoute = useRouteStore((state) => state.setRoute);

  useEffect(() => {
    setRoute([
      { name: 'Inicio', url: '/administracion' },
      { name: 'Géneros', url: '/administracion/generos' },
    ]);
    getGenres().then((res) => {
      setGenres(res.data);
      setLoading(false);
    });
  }, []);

  const filtered = genres.filter((g) => g.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className='font-montserrat w-full'>
      <div className='flex items-center justify-between pb-1 mb-5 border-b-2'>
        <h1 className='font-semibold text-xl'>Géneros</h1>
        <Link
          to='/administracion/generos/nuevo'
          className='flex items-center gap-1.5 bg-red-1 hover:bg-red-2 text-white text-sm font-semibold px-3 py-1.5 rounded-lg transition-colors'
        >
          <svg className='w-4 h-4' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth={2.5}>
            <path strokeLinecap='round' strokeLinejoin='round' d='M12 4v16m8-8H4' />
          </svg>
          Nuevo género
        </Link>
      </div>

      <div className='w-full md:w-1/2 mb-4'>
        <SearchBar value={search} setValue={setSearch} onSubmit={() => {}} className='w-full' autoSubmit />
      </div>

      <div className='flex border-b pb-1 text-sm text-slate-500 mb-2'>
        <div className='flex-1 px-2'>Nombre</div>
        <div className='w-24 text-center'>Acción</div>
      </div>

      <div className='flex flex-col gap-2'>
        {!loading ? (
          filtered.length > 0 ? (
            filtered.map((genre) => (
              <div
                key={genre._id}
                className='flex items-center bg-white border border-gray-100 rounded-lg px-4 py-3 shadow-sm'
              >
                <div className='flex-1 font-semibold text-gray-800'>{genre.name}</div>
                <Link
                  to={`/administracion/generos/${genre._id}`}
                  className='flex items-center gap-1 text-xs font-semibold text-red-1 border border-red-1 px-3 py-1.5 rounded-lg hover:bg-red-1 hover:text-white transition-colors'
                >
                  <svg className='w-3.5 h-3.5' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth={2}>
                    <path strokeLinecap='round' strokeLinejoin='round' d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' />
                  </svg>
                  Editar
                </Link>
              </div>
            ))
          ) : (
            <p className='text-sm text-gray-400 italic text-center py-12'>No se encontraron géneros.</p>
          )
        ) : (
          <div className='flex flex-col gap-2'>
            {[...Array(6)].map((_, i) => (
              <div key={i} className='h-12 w-full rounded-lg animate-pulse bg-gray-100' />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminGenres;
